import { useColorModeValue } from "@chakra-ui/react";

import { StageColors } from "@reflag/shared/stageAPI";

export const useStagesColor = () => {
  return useColorModeValue(
    StageColors.map((color) => `${color}.400`),
    StageColors.map((color) => `${color}.400`),
  );
};

export const useStageColor = (color: string) => {
  return useColorModeValue(`${color}.400`, `${color}.400`);
};
